import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { CountryDto } from "@api/country-dto";
import { PropType, toRef } from "vue";
import { useSelectField } from "./select";
import SelectBase from "./SelectBase.vue";
import publicFormApi from "@/publicFormApi";
import { getCitizenshipTranslation } from "@/helpers";


export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySelect',
  props: {
	valueSingle: {
		type: [Object, null] as PropType<CountryDto | null | undefined>,
	},
	valueMulti: {
		type: [Array, null] as PropType<CountryDto[] | null | undefined>,
	},
	ajax: {
		type: Boolean,
		default: false,
	},
	isInvalid: {
		type: Boolean,
	},
	id: {
		type: String,
	},
	lowercase: {
		type: Boolean,
		default: false,
	},
	isCitizenship: {
		type: Boolean,
		required: false,
		default: false,
	},
},
  emits: [
	"update:valueSingle",
	"update:valueSingleId",
	"update:valueMulti",
	"blur",
],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const props = __props;

const {
	cValueSingle,
	cValueMulti,
	optionGenerator,
	optionIdentifier,
	optionsGetter,
	nonAjaxOptions,
} = useSelectField<CountryDto>(
	toRef(() => props.valueSingle),
	toRef(() => props.valueMulti),
	toRef(() => props.ajax),
	(val) => emit("update:valueSingle", val),
	(val) => emit("update:valueSingleId", val?.id || null),
	(val) => emit("update:valueMulti", val),
	(search?: string, page?: number) => publicFormApi.call.form.get.countriesSearch(search, page),
	(country: CountryDto) => {
		let text = "";
		if (props.isCitizenship) {
			text = getCitizenshipTranslation(country) ?? "";
		} else if (country.finName != country.engName) {
			text = country.finName + " (" + country.engName + ")";
		} else {
			text = country.finName || "";
		}

		if (props.lowercase) {
			text = text.toLowerCase();
		}

		return {
			text,
			value: country,
		};
	},
	(val) => val.id
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SelectBase, {
    valueMulti: _unref(cValueMulti),
    "onUpdate:valueMulti": _cache[0] || (_cache[0] = ($event: any) => (_isRef(cValueMulti) ? (cValueMulti).value = $event : null)),
    valueSingle: _unref(cValueSingle),
    "onUpdate:valueSingle": _cache[1] || (_cache[1] = ($event: any) => (_isRef(cValueSingle) ? (cValueSingle).value = $event : null)),
    ajax: __props.ajax,
    onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('blur'))),
    id: __props.id,
    optionGenerator: _unref(optionGenerator),
    optionComparer: _unref(optionIdentifier),
    optionLoader: _unref(optionsGetter),
    options: _unref(nonAjaxOptions)
  }, null, 8, ["valueMulti", "valueSingle", "ajax", "id", "optionGenerator", "optionComparer", "optionLoader", "options"]))
}
}

})